import { useCallback } from 'react';
import { ShiftGeneratorTaskService } from 'src/api/ShiftGeneratorTaskService';
import { invalidateShiftGeneratorResultData } from '@stores/shiftGeneratorResultStore';
import { invalidateShiftGeneratorTaskData } from '@stores/shiftGeneratorTaskStore';

type ExecuteTasks = (taskIds: string[]) => Promise<unknown>;

/*
 * The generation runs asynchronously — the results change when the
 * runner finishes, not here. The invalidation (plus the caches' zero
 * ttl) ensures every later read revalidates instead of serving the
 * pre-trigger state as fresh.
 */
const useExecuteTasks = (orgId?: string): { executeTasks: ExecuteTasks } => {
    const executeTasks = useCallback<ExecuteTasks>(
        async (taskIds) => {
            if (!orgId) {
                throw new Error('useExecuteTasks requires an org id');
            }

            const response = await ShiftGeneratorTaskService.executeTasks(
                orgId,
                taskIds,
            );

            if (response === undefined) {
                return undefined;
            }

            invalidateShiftGeneratorTaskData();
            invalidateShiftGeneratorResultData();

            return response;
        },
        [orgId],
    );

    return { executeTasks };
};

export default useExecuteTasks;
